<template>
  <div id="areasList" class="contenedor">
    <Sidebar></Sidebar>
    <loader :show="show" />
    <v-container fluid class="base text-center ma-0 px-0 pt-3 pb-0">
      <v-row no-gutters class="titulo">Lista de Áreas</v-row><br /><br />
      <v-row no-gutters class="mt-4">
        <v-col
          cols="12"
          lg="6"
          md="6"
          sm="6"
          xs="6"
          class="ml-12"
          align-self="end"
        >
          <v-card-title style="width: 90% !important" class="ml-12">
            <label for="enterprise" class="ml-5 mr-2" style="font-size: 0.7em"
              >Empresa Pagadora</label
            >
            <select
              name="enterprise"
              id="enterprise"
              v-model="enterprise"
              @change="obtenerEmpresa()"
              class="selectEdit"
              style="
                font-size: 0.6em;
                padding-left: 5px;
                border-radius: 5px;
                height: 35px;
              "
            >
              <option selected disabled value="0">Selecciona Empresa</option>
              <option
                v-for="enterprise in enterprises"
                :key="enterprise.id"
                v-bind:value="enterprise.id"
              >
                {{ enterprise.razonSocial }}
              </option>
            </select>
          </v-card-title>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="6" xs="6" class="ml-n12">
          <v-card-title style="width: 90% !important">
            <router-link to="/catalogue" id="nuevaArea">
              <button class="boton mr-5" style="float: none; font-size: 0.7em">
                <span class="px-2 pt-3 ma-0 fa-1x">
                  <font-awesome-icon icon="calendar-alt">
                    ></font-awesome-icon
                  > </span
                >Alta área
              </button>
            </router-link>
            <v-text-field
              style="margin-right: 17%"
              v-model="search"
              append-icon="search"
              label="Buscador"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        </v-col>
      </v-row>
      <v-row no-gutters class="datos pa-0" style="height: auto !important">
        <v-card style="width: 100%; background: rgb(199, 195, 199) !important">
          <v-data-table
            :headers="headers"
            :items="areas"
            :search="search"
            class="elevation-2 text--dark table-striped"
            :items-per-page="5"
            :no-results-text="'No se encontraron incidencias'"
            :no-data-text="'No hay datos'"
            :footer-props="{
              'items-per-page-text': 'Áreas por página',
              'items-per-page': [5, 10, 15],
              'items-per-page-all-text': 'Todos',
              'items-per-page-options': [5],
              'loading-text': 'Obteniendo datos... Por favor espere',
              'no-data-text': 'No hay datos...',
              'no-results-text': 'No se encontraron incidencias',
            }"
          >
            <template v-slot:no-data>
              <v-alert :value="true" color="#ffffff" icon="warning">
                <p style="color: black">No hay datos en sistema ...</p>
              </v-alert>
            </template>
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.Id"
                  :class="{ selectedRow: item === selectedItem }"
                >
                  <td class="text-sm-center">{{ item.id }}</td>
                  <td class="text-sm-center">{{ item.nombreArea }}</td>
                  <td class="text-sm-center">{{ item.nivelJerarquico }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon
                      color="#717171"
                      small
                      class="mr-6"
                      @click="editItem(item)"
                      >fa-edit</v-icon
                    >
                    <v-icon
                      color="#717171"
                      small
                      class="mr-6"
                      @click="viewItem(item)"
                      >fa-eye</v-icon
                    >
                    <v-icon color="red" small @click="temporal(item)"
                      >fa-trash-alt</v-icon
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <v-card-actions class="justify-center">
            <router-link to="/jobList">
              <button
                class="boton"
                style="float: none !important; font-size: 1em"
              >
                Siguiente
              </button>
            </router-link>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-container>

    <!--DIALOG DE DATOS-->
    <v-dialog v-model="dialog" scrollable max-width="300px">
      <v-card>
        <v-card-title class="orange white--text"
          >Información de Áreas</v-card-title
        >
        <v-card-text id="info">
          <div class="form-group mt-5">
            <label>Empresa:</label>
            {{ empresa }}
          </div>
          <div class="form-group">
            <label>Nombre de Área:</label>
            {{ nombreArea }}
          </div>
          <div class="form-group">
            <label>Nombre Corto:</label>
            {{ nombreCorto }}
          </div>
          <div class="form-group">
            <label>Nivel Jerárquico:</label>
            {{ nivel }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Aceptación de acciones-->
    <v-dialog v-model="advice" width="400">
      <v-card>
        <v-card-title class="red white--text">
          <span class="headline">Aviso</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 style="text-align: center">{{ respuesta }}</h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" text @click="advice = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="deleteItem()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Confirmación de datos-->
    <v-dialog v-model="confirmation" width="400">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Área</span>
        </v-card-title>
        <v-card-text>
          <br />
          <h3 class="text-lg-center text-sm-center text-md-center">
            {{ respuesta }}
          </h3>
          <br />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="confirmation = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--Editar item-->
    <v-dialog v-model="edit" width="350">
      <v-card>
        <v-card-title class="orange white--text">
          <span class="headline">Edición de datos</span>
        </v-card-title>
        <v-card-text>
          <!--EMPRESA-->
          <v-row>
            <div class="form-group mt-5 mb-2">
              <label for="enterprise" class="ml-2 mr-12">Empresa</label>
              <select
                name="enterprise"
                id="enterprise"
                v-model="empresa"
                @change="obtenerEmpresa()"
                class="ml-9 mt-n6 selectEdit"
                style="width: 170px !important"
                disabled
              >
                <option selected disabled value="0">Selecciona Empresa</option>
                <option
                  v-for="enterprise in enterprises"
                  :key="enterprise.id"
                  v-bind:value="enterprise.id"
                >
                  {{ enterprise.razonSocial }}
                </option>
              </select>
            </div>
          </v-row>
          <!--NOMBRE DE AREA-->
          <v-row>
            <div class="form-group mb-2">
              <label for="area" class="ml-2">Nombre de Área</label>
              <input
                type="text"
                name="area"
                id="area"
                placeholder="Obligatorio"
                class="ml-9 selectEdit"
                autocomplete="false"
                required
                maxlength="30"
                v-model="nombreArea"
                @keypress="alfaNumerico($event)"
              />
            </div>
          </v-row>
          <!--NOMBRE CORTO-->
          <v-row>
            <div class="form-group mb-2">
              <label for="corto" class="ml-2 mr-3">Nombre Corto</label>
              <input
                type="text"
                name="corto"
                id="corto"
                placeholder="Obligatorio"
                class="ml-9 selectEdit"
                autocomplete="false"
                required
                maxlength="30"
                @keypress="alfaNumerico($event)"
                v-model="nombreCorto"
              />
            </div>
          </v-row>
          <!--NIVEL JERARQUICO-->
          <v-row>
            <div class="form-group mt-1">
              <label for="enterprise" class="ml-2 mr-1">Nivel Jerarquico</label>
              <select
                name="enterprise"
                id="enterprise"
                class="ml-8 mt-n6 selectEdit"
                style="width: 170px !important"
                v-model="nivel"
              >
                <option selected disabled value="0">Selecciona Nivel</option>
                <option
                  v-for="level in niveles"
                  :key="level.id"
                  v-bind:value="level.id"
                >
                  {{ level.name }}
                </option>
              </select>
              <br />
              <br />
              <label v-if="vacio" style="color: red"
                >*Se deben especificar todos los campos</label
              >
            </div>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" text @click="aux()">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="validacion()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar.vue";
import Loader from "@/components/Loader";
export default {
  components: {
    Sidebar,
    Loader,
  },
  data() {
    return {
      stepn: "4-N",
      search: "",
      show: false,
      dialog: false,
      advice: false,
      confirmation: false,
      niveles: [],
      headers: [
        {
          text: "N°",
          align: "center",
          sortable: false,
          value: "id",
        },
        {
          text: "Nombre de Área/Departamento",
          align: "center",
          value: "nombreArea",
        },
        { text: "Nivel jerárquico", value: "nivelJerarquico", align: "center" },
        {
          text: "Editar  /   Ver  / Eliminar",
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
      enterprise: 0,
      enterprises: [],
      selectedItem: null,
      edit: false,
      vacio: false,
      areas: [],
      nivel: 0,
      nombreCorto: "",
      nombreArea: "",
      empresa: 0,
      respuesta: "",
      id: 0,
    };
  },
  methods: {
    alfaNumerico: function (evt) {
      var regex = new RegExp("^[a-zA-ZÀ-ÿ\u00f1\u00d10-9 ]+$"); // Letras,espacio y números
      var str = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (regex.test(str)) {
        return true;
      }
      evt.preventDefault();
      return false;
    },
    nombre() {
      localStorage.stepn = this.stepn;
    },
    listar() {
      this.show = true;
      axios
        .get(Server + "/empresas")
        .then((response) => {
          this.enterprises = response.data;
          this.show = false;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
        });
    },
    obtenerEmpresa() {
      this.areas = [];
      this.show = true;
      axios
        .get(Server + "/areas")
        .then((response) => {
          this.show = false;
          //console.log("resultado de todas las areas");
          //console.log(response);
          var auxAreas = response.data;
          auxAreas.forEach((value, index) => {
            if (value.empresaId == this.enterprise) {
              this.areas.push({
                id: value.id,
                nombreArea: value.nombreArea,
                nombreCorto: value.nombreAreaCorto,
                empresa: value.empresaId,
                nombreEmpresa: value.empresa,
                nivelJerarquico: value.nivelJerarquico,
              });
            }
          });
          //console.log("resultado de areas por empresa");
          //console.log(this.areas);
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
        });
    },
    viewItem(item) {
      this.empresa = item.empresa;
      this.nombreArea = item.nombreArea;
      this.nombreCorto = item.nombreCorto;
      this.nivel = item.nivelJerarquico;
      var emp = this.enterprises.find((empresa) => empresa.id === item.empresa);
      this.empresa = emp.razonSocial;
      var emp = "";
      this.dialog = true;
    },
    temporal(item) {
      console.log(item);
      this.id = item.id;
      this.reason = item.reason;
      this.respuesta =
        "¿ Seguro que desea eliminar el Área de " + item.nombreArea + " ?";
      this.advice = true;
    },
    deleteItem() {
      this.advice = false;
      console.log("Ingreso a eliminar el dato con id: " + this.id);
      this.respuesta = "";
      this.show = true;
      axios
        .delete(Server + "/areas/" + this.id)
        .then((response) => {
          //console.log(response);
          this.show = false;
          this.id = "";
          this.respuesta = "El elemento fue eliminado con éxito";
          this.confirmation = true;
          this.obtenerEmpresa();
        })
        .catch((e) => {
          //console.log(e);
          this.show = false;
          this.id = "";
          this.respuesta = "El elemento no fue eliminado";
          this.confirmation = true;
        });
    },
    editItem(item) {
      //console.log("Ingreso a editar area" + item.id);
      //console.log(item);
      this.id = item.id;
      this.empresa = item.empresa;
      this.nombreArea = item.nombreArea;
      this.nombreCorto = item.nombreCorto;
      this.nivel = item.nivelJerarquico;
      this.edit = true;
    },
    aux() {
      this.edit = false;
      this.empresa = 0;
      this.nombreArea = "";
      this.nombreCorto = "";
      this.nivel = "";
      this.vacio = false;
    },
    validacion: function () {
      this.errors = [];
      if (this.empresa == "" || this.empresa == 0) {
        this.errors.push("Se debe especificar la empresa.");
      }
      if (this.nombreArea == "" || this.nombreArea == " ") {
        this.errors.push("Se debe especificar el nombre del área.");
      }
      if (this.nombreCorto == "" || this.nombreCorto == " ") {
        this.errors.push("Se debe especificar el nombre corto del área.");
      }
      if (this.nivel == "" || this.nivel == 0) {
        this.errors.push("Se debe especificar el nivel jerárquico.");
      }
      if (this.errors.length == 0) {
        this.edit = false;
        this.vacio = false;
        return this.editar();
      } else {
        this.vacio = true;
      }
    },
    editar() {
      console.log(this.id);
      this.respuesta = "";
      this.show = true;
      axios
        .put(Server + "/areas/" + this.id, {
          Id: this.id,
          EmpresaId: this.empresa,
          NombreArea: this.nombreArea,
          NombreAreaCorto: this.nombreCorto,
          NivelJerarquico: parseInt(this.nivel),
        })
        .then((response) => {
          this.show = false;
          console.log(response);
          this.id = "";
          this.empresa = 0;
          this.nombreArea = "";
          this.nombreCorto = "";
          this.nivel = 0;
          this.respuesta = "El area fue actualizada con éxito.";
          this.obtenerEmpresa();
          this.confirmation = true;
        })
        .catch((e) => {
          console.log(e);
          this.show = false;
          this.id = "";
          this.empresa = 0;
          this.nombreArea = "";
          this.nombreCorto = "";
          this.nivel = 0;
          this.respuesta = "El area no fue actualizada con éxito.";
          this.obtenerEmpresa();
          this.confirmation = true;
        });
    },
  },
  created() {
    this.nombre();
    this.listar();
    this.obtenerEmpresa();
    for (let index = 1; index <= 99; index++) {
      this.niveles.push({
        id: index,
        name: index.toString(),
      });
    }
  },
};
</script>
